import * as moment_ from 'moment'
import { UserCreate } from '../models/User'
import { Region } from '../models/Region'

export class ViewValidation {
	public isEmail(value: string): boolean {
		const isTrue = /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
			value
		)
		if (isTrue) return true

		return false
	}

	public isSubdomainValid(value: string): boolean {
		const isTrue = /^[a-zA-Z]+$/.test(value)
		if (isTrue) return true

		return false
	}

	public isPasswordValid(value: string): boolean {
		value = value || ''
		if (value.length >= 8) return true

		return false
	}

	public isProcessValid(value: string): boolean {
		value = value || ''
		if (value.length >= 1) return true

		return false
	}

	public isStrongPasswordValid(value: string): boolean {
		const result = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])(?=.{8,})/.test(
			value
		)

		return result
	}

	public isChangePasswordValid(
		value: string,
		value2?: string,
		btnSave?: boolean
	): boolean {
		const isStrongPassword = this.isStrongPasswordValid(value2)
		if (isStrongPassword) {
			if (!value2 && !btnSave) {
				return true
			}
			if (value != undefined && value2 != undefined && value === value2) {
				return true
			} else {
				return false
			}
		}

		return false
	}

	public isStringValid(value: string): boolean {
		value = value || ''
		value = value.trim()
		if (value.length >= 1) return true

		return false
	}

	public isNameValid(value: string): boolean {
		value = value || ''
		value = value.trim()
		const isTrue = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/.test(value)
		if (isTrue) {
			if (value.length >= 1) return true
		}

		return false
	}

	public isAdressValid(value: string): boolean {
		value = value || ''
		value = value.trim()
		if (value.length >= 1) return true

		return false
	}

	public isProfileValid(value: string): boolean {
		if (value) return true

		return false
	}

	public isSelected(value: string): boolean {
		if (value) return true

		return false
	}

	public isCPF(value: string): boolean {
		const isTrue = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(value)
		if (isTrue) return true

		return false
	}

	public isCNPJ(value: string): boolean {
		const isTrue = /^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}$/.test(
			value
		)
		if (isTrue) return true

		return false
	}

	public isTel(value: string): boolean {
		const isTrue = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/.test(
			value
		)
		if (isTrue) return true

		return false
	}

	public isQtdValid(value: number): boolean {
		if (value > 0) {
			const isTrue = /^\d[0-9]{0,4}$/.test(String(value))
			if (isTrue) return true
		} else {
			return false
		}

		return false
	}

	public isEqualZeroAndNumber(value: number): boolean {
		if (value >= 0) {
			const isTrue = /^\d[0-9]{0,4}$/.test(String(value))
			if (isTrue) return true
		} else {
			return false
		}

		return false
	}

	public isSignatureDateValid(date: string, edit?: boolean): boolean {
		if (edit) return true
		if (date == null || date == '') return true
		const newdate = date
			.split('/')
			.reverse()
			.join('-')
		const dateAssinatura = moment_(newdate)
		const dataAtual = moment_(new Date())
		const result = moment_(dateAssinatura).isBefore(dataAtual)

		return result
	}

	public isValidityValid(
		date: string,
		dataSignature?: string,
		edit?: boolean
	): boolean {
		if (edit) return true
		if (date == null || date == '') return true
		const newdate = date
			.split('/')
			.reverse()
			.join('-')
		const dateValidade = moment_(newdate)
		const dataAtual = moment_(new Date())
		if (dataSignature) {
			const newdate2 = dataSignature
				.split('/')
				.reverse()
				.join('-')
			const dateAssinatura = moment_(newdate2)

			return moment_(dateValidade).isAfter(dateAssinatura)
		} else {
			return moment_(dateValidade).isAfter(dataAtual)
		}
	}

	public isValidDate(date: string): boolean {
		return moment_(date, 'DD/MM/YYYY', true).isValid()
	}

	public differenceBetweenDates(dateStart: string, dateEnd: string): boolean {
		return (
			moment_(dateEnd, 'DD/MM/YYYY') >= moment_(dateStart, 'DD/MM/YYYY')
		)
	}

	// Encapsulateds
	public isValidFormLogin(email: string, pass: string): boolean {
		if (this.isEmail(email) && this.isPasswordValid(pass)) return true

		return false
	}

	public isValidFormAdminArbolink(
		name: string,
		cpf: string,
		email: string,
		tel: string,
		roles: Array<string>
	): boolean {
		if (
			this.isNameValid(name) &&
			this.isCPF(cpf) &&
			this.isEmail(email) &&
			this.isTel(tel) &&
			this.isRole(roles)
		) {
			return true
		}

		return false
	}

	public isValidFormUserCompany(user: UserCreate) {
		if (
			this.isNameValid(user.name) &&
			this.isCPF(user.cpf) &&
			this.isEmail(user.email) &&
			this.isTel(user.telephone) &&
			this.isRole(user.roles) &&
			this.isCompanyServiceProvider(user) &&
			this.isCrea(user) &&
			this.assignmentValid(user.assignments)
		) {
			return true
		}

		return false
	}

	public isValidFormChangeAdmin(
		name: string,
		cpf: string,
		email: string,
		tel: string
	): boolean {
		if (
			this.isNameValid(name) &&
			this.isCPF(cpf) &&
			this.isEmail(email) &&
			this.isTel(tel)
		) {
			return true
		}

		return false
	}

	public isRole(roles: Array<string>) {
		if (roles.length > 0) return true

		return false
	}

	public isCompanyServiceProvider(user: UserCreate) {
		const isOperator = Boolean(user.roles.includes('OPERATOR'))
		const companyServiceProviderSelected = Boolean(user.companyServiceProvider)

		if (!isOperator) {
			return true
		} else if (isOperator && companyServiceProviderSelected) {
			return true
		} else {
			return false
		}
	}

	public assignmentValid(assignments: Array<string>) {
		if (assignments.length > 0) return true

		return false
	}

	public isCrea(user: UserCreate) {
		const isEvaluator = Boolean(user.roles.includes('EVALUATOR'))

		if (!isEvaluator) {
			return true
		} else if (isEvaluator && this.isStringValid(user.crea)) {
			return true
		} else {
			return false
		}
	}

	public isValidRegion(region: Region) {
		if (
			region.color !== '' &&
			region.name != '' &&
			region.coordinates.length >= 3
		) {
			return true
		} else {
			return false
		}
	}

	public isValidFormEvaluator(
		name: string,
		cpf: string,
		email: string,
		profile: string,
		tel: string,
		crea: string
	): boolean {
		if (
			this.isNameValid(name) &&
			this.isCPF(cpf) &&
			this.isEmail(email) &&
			this.isProfileValid(profile) &&
			this.isTel(tel) &&
			crea
		) {
			return true
		}

		return false
	}

	public isInDistanceRange(value: string | null | undefined): boolean {
		if (value === null || value === undefined || value === '') {
			return true
	}

	 const isInRange: boolean = parseInt(value) >= 50 && parseInt(value) <= 500

	 return isInRange
	}


	public validateRequester(appSolicitante: boolean, publicPanel: boolean, distance: string, subdomain: string): boolean {
		if (!appSolicitante) {
			return true
		}

		if ((appSolicitante || publicPanel) && subdomain && this.isSubdomainValid(subdomain) && !distance) {
			return true
		}

		if (appSolicitante && subdomain && this.isSubdomainValid(subdomain) && distance) {
			return this.isInDistanceRange(distance)
		}

		return false
	}

	public isValidFormCompany(
		social_name: string,
		street: string,
		telephone: string,
		cnpj: string,
		email: string,
		responsible_name: string,
		responsible_telephone: string,
		license_type: string,
		qtd_admins: number,
		qtd_evaluators: number,
		qtd_operators: number,
		qtd_inventors: number,
		date: string,
		date2: string,
		ie: string,
		edit: boolean,
		mediaCompany: boolean,
		appSolicitante: boolean,
		subdomain: string,
		demandRadiusDelimiter: string,
		publicPanel: boolean
	): boolean {
		if (
			this.isStringValid(social_name) &&
			this.isAdressValid(street) &&
			this.isCNPJ(cnpj) &&
			this.isEmail(email) &&
			this.isNameValid(responsible_name) &&
			this.isTel(responsible_telephone) &&
			this.isNameValid(license_type) &&
			this.isEqualZeroAndNumber(qtd_admins) &&
			this.isEqualZeroAndNumber(qtd_evaluators) &&
			this.isEqualZeroAndNumber(qtd_operators) &&
			this.isEqualZeroAndNumber(qtd_inventors) &&
			this.isSignatureDateValid(date, edit) &&
			this.isIEValid(ie) &&
			this.isValidityValid(date2, date, edit) &&
			mediaCompany && this.validateRequester(appSolicitante, publicPanel, demandRadiusDelimiter, subdomain)
		) {
			return true
		}
	}

	public isValidFormCompanyProvider(
		socialName: string,
		cnpj: string,
		street: string,
		city: string,
		email: string,
		telephone: string,
		stateRegistration: string,
		handlerOperations: Array<number>
	): boolean {

		if (
			this.isStringValid(socialName) &&
			this.isAdressValid(street) &&
			this.isAdressValid(city) &&
			this.isCNPJ(cnpj) &&
			this.isEmail(email) &&
			this.isTel(telephone) &&
			this.isStringValid(stateRegistration) &&
			handlerOperations.length > 0
		) {
			return true
		}

		return false
	}

	public isIEValid(value: string): boolean {
		value = value || ''
		value = value.trim()
		if (value.length >= 1) return true

		return false
	}

	public isAlphaFilled(value: string): boolean {
		value = value || ''
		value = value.trim()
		if (value.length >= 1) return true

		return false
	}

	public isValidFormChangePassword(
		password: string,
		newPassword: string,
		rePassword: string
	): boolean {
		if (
			this.isPasswordValid(password) &&
			this.isChangePasswordValid(newPassword, rePassword, true)
		) {
			return true
		}

		return false
	}

	public isValidFormDemandSchedule(
		requester: string,
		email_requester: string,
		cpf_requester: string,
		telephoneRequester: string,
		street: string
	): boolean {
		if (
			this.isNameValid(requester) &&
			this.isEmail(email_requester) &&
			this.isCPF(cpf_requester) &&
			this.isTel(telephoneRequester) &&
			this.isAdressValid(street)
		) {
			return true
		}

		return false
	}


	public isValidFormChangeDemandRequester(
		requester?: string,
		email_requester?: string,
		cpf_requester?: string,
		telephoneRequester?: string
	): boolean {
		if (!this.isNameValid(requester)) {
			return false
		}

		if (!this.isEmail(email_requester)) {
			return false
		}

		if (!this.isCPF(cpf_requester)) {
			return false
		}

		if (!this.isTel(telephoneRequester)) {
			return false
		}

		return true
	}


	public isValidDataCvs(
		requester: string,
		email_requester: string,
		cpf_requester: string,
		tel_requester: string,
		lat: string,
		lng: string,
		street: string,
		companyId: string,
		reference: string,
		nameProblem: string

	): boolean {
		if (
			this.isNameValid(requester) &&
			this.isEmail(email_requester) &&
			this.isCPF(cpf_requester) &&
			this.isTel(tel_requester) &&
			this.isStringValid(lat) &&
			this.isStringValid(lng) &&
			this.isAdressValid(street) &&
			this.isStringValid(companyId) &&
			this.isStringValid(reference) &&
			nameProblem
		) {
			return true
		}

		return false
	}

	public isValidDataCvsInventory(
		requester: string,
		email_requester: string,
		addres: string,
		lat: number,
		lng: number,
		media_url: Array<string>,
		species: string,
		heightTree: number,
		fusteValue: number,
		fusteType: string,
		dapType: string,
		averageDap: number,
		company: string,
		handlerOperations: Array<{
			handlerOperation: string
		}>,
		inventorAnswers: Array<{
			idMongo: string;
			text: string;
		}>,
		category_tree: number
	): boolean {
		if (
			requester &&
			email_requester &&
			addres &&
			lat &&
			lng &&
			media_url.length > 0 &&
			species &&
			heightTree &&
			fusteValue &&
			fusteType &&
			dapType &&
			averageDap &&
			company &&
			handlerOperations.length > 0 &&
			inventorAnswers.length > 0 &&
			category_tree
		) {
			return true
		}

		return false
	}


	public isValidFormDemand(
		requester: string,
		email_requester: string,
		cpf_requester: string,
		street: string
	): boolean {
		if (
			this.isNameValid(requester) &&
			this.isEmail(email_requester) &&
			this.isCPF(cpf_requester) &&
			this.isAdressValid(street)
		) {
			return true
		}

		return false
	}

	public isValidFormEvaluation(
		question: string,
		scale_checked: boolean,
		scale_value: number,
		alternatives: any,
		other_checked: boolean,
		other_text: string
	): boolean {
		if (
			this.isAlphaFilled(question) &&
			alternatives &&
			alternatives.length > 0
		) {
			if (other_checked && !this.isAlphaFilled(other_text)) {
				return false
			}
			if (scale_checked && !this.isQtdValid(scale_value)) {
				return false
			}

			if (
				scale_checked &&
				alternatives.filter(alt => {
					if (!alt.text || !this.isAlphaFilled(alt.text)) {
						return true
					}

					return false
				}).length > 0
			) {
				return false
			}

			if (
				!scale_checked &&
				alternatives.filter(alt => {
					if (!this.isEqualZeroAndNumber(alt.value)) {
						return true
					}

					return false
				}).length > 0
			) {
				return false
			}

			return true
		}

		return false
	}

	public isValidFormOperacaoManejo(
		operation: string,
		instructions: string,
		description: string,
		gallery: string,
		specialRecommendation: string,
		typeOperation: string
	): boolean {
		if (
			this.isStringValid(operation) &&
			this.isStringValid(instructions) &&
			this.isStringValid(description) &&
			specialRecommendation != null &&
			typeOperation != null &&
			gallery &&
			gallery.length > 0
		) {
			return true
		}

		return false
	}

	public isValidFormReport(
		responsible: string,
		file: string,
		risk: any
	): boolean {
		if (
			this.isNameValid(responsible) &&
			this.isStringValid(file) &&
			this.isSelected(risk)
		) {
			return true
		}

		return false
	}

	public isValidDateDashboard(dateStart: string, dateEnd: string): boolean {
		if (
			this.isValidDate(dateStart) &&
			this.isValidDate(dateEnd) &&
			this.differenceBetweenDates(dateStart, dateEnd)
		) {
			return true
		}
		return false
	}

	public formatDate(date: any): string {
		if (!date) return '-'

		return moment_(date).format('DD/MM/YYYY')

		// return date
	}

	public isValidFormSection(
		name: string,
		description: string
	) {
		if (
			this.isStringValid(name) &&
			this.isStringValid(description)
		) {
			return true
		}

		return false
	}
}
